import type { InventoryBalance } from "../api/types";

/**
 * Case-insensitive match on item name, shop, zone — and barcode.
 *
 * G-83 added the barcode, and it is the reason the scan button works at all:
 * without it a scanned code matched nothing, because a code is not a name and
 * the haystack held only names. Pointing a camera at a box on the shelf found
 * zero rows while the item was sitting in front of you.
 *
 * TYPED CODES MATCH TOO, not only scanned ones. The barcode is part of the same
 * haystack rather than a separate mode, so a florist reading digits off a label
 * gets the same answer as the camera — and there is one rule to keep right
 * instead of two.
 */
export function matchesInventorySearch(
  row: InventoryBalance,
  query: string,
  /**
   * G-132: the staff inventory page says "Name, barcode, colour" in its search
   * box, so it passes `includeColour`. Opt-in because the kiosk finder shares
   * this matcher and stays exactly as it was (its colour names are not in the
   * language the florist is reading).
   */
  options: { includeColour?: boolean } = {},
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const colour = options.includeColour ? ` ${row.item.color?.name ?? ""}` : "";
  const hay = `${row.item.name}${colour} ${row.location.name} ${row.zone.name} ${
    row.item.barcode ?? ""
  }`.toLowerCase();
  return hay.includes(q);
}
